import { notifications } from '@mantine/notifications';
import { IconBell } from '@tabler/icons-react';
import { notificationUri } from '~/shared/constants';

export const notifyOfNewOrders = async () => {
    notifications.show({
        color: 'red',
        autoClose: true,
        title: 'Уведомление',
        message: 'Мерчант подтвердил перевод по одному из ордеров',
        icon: <IconBell />,
    });
    await new Audio(notificationUri).play().then();
};
